
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import {
  warehouseSetupEnterUsername,
  warehouseSetupEnterPassword,
  warehouseSetupEnterHost,
  warehouseSetupEnterPort,
  warehouseSetupEnterDatabase,
  warehouseSetupSubmitConnectForm,
  warehouseSetupEnterProjectId
} from 'actions'
import { getWarehouseMetadataById } from 'selectors'
import CreateBigQueryForm from '../../components/create-bigquery-form'
import Form from '../../components/warehouse-setup-connect-form'

const WarehouseSetupConnectFormContainer = props => {
  if (props.databaseSlug === 'bigquery') {
    return (
      <CreateBigQueryForm
        isValid={props.isValid}
        isSubmitting={props.isSubmitting}
        onSubmit={props.onCreateBigQuery}
        projectId={props.projectId}
        onEnterProjectId={props.onEnterProjectId} />
    )
  }

  return (
    <Form
      isValid={props.isValid}
      isSubmitting={props.isSubmitting}
      onSubmit={props.onSubmit}

      username={props.username}
      password={props.password}
      host={props.host}
      port={props.port}
      database={props.database}

      onEnterUsername={props.onEnterUsername}
      onEnterPassword={props.onEnterPassword}
      onEnterHost={props.onEnterHost}
      onEnterPort={props.onEnterPort}
      onEnterDatabase={props.onEnterDatabase} />
  )
}

function mapStateToProps (state) {
  const {
    databaseId,
    settings,
    bigquery
  } = state.application.warehouseSetup
  const database = getWarehouseMetadataById(state, databaseId) || {}
  return {
    ...settings,
    ...bigquery,
    isSubmitting: state.application.warehouseSetup.isConnecting,
    isValid: state.application.warehouseSetup.areSettingsValid,
    databaseSlug: database.slug
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {
    // bigquery
    onEnterProjectId: id => dispatch(warehouseSetupEnterProjectId(id)),
    onCreateBigQuery: data => dispatch(warehouseSetupSubmitConnectForm({
      workspaceSlug: ownProps.workspaceSlug,
      databaseId: ownProps.databaseId,
      data: {
        // HACK: the bigquery connector expects these keys
        // TODO(stephenmathieson): fix this in our reducer, rather than compensating for it in this action
        'gc-project': data.projectId
      }
    })),

    // redshift/postgres
    onEnterUsername: username => dispatch(warehouseSetupEnterUsername(username)),
    onEnterPassword: password => dispatch(warehouseSetupEnterPassword(password)),
    onEnterHost: host => dispatch(warehouseSetupEnterHost(host)),
    onEnterPort: port => dispatch(warehouseSetupEnterPort(port)),
    onEnterDatabase: database => dispatch(warehouseSetupEnterDatabase(database)),
    onSubmit: data => dispatch(warehouseSetupSubmitConnectForm({
      databaseId: ownProps.databaseId,
      workspaceSlug: ownProps.workspaceSlug,
      data
    }))
  }
}

WarehouseSetupConnectFormContainer.propTypes = {
  database: PropTypes.string.isRequired,
  databaseSlug: PropTypes.string.isRequired,
  host: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  onCreateBigQuery: PropTypes.func.isRequired,
  onEnterDatabase: PropTypes.func.isRequired,
  onEnterHost: PropTypes.func.isRequired,
  onEnterPassword: PropTypes.func.isRequired,
  onEnterPort: PropTypes.func.isRequired,
  onEnterProjectId: PropTypes.func.isRequired,
  onEnterUsername: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  port: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]).isRequired,
  projectId: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired
}

WarehouseSetupConnectFormContainer.displayName = 'WarehouseSetupConnectFormContainer'

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseSetupConnectFormContainer)



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/containers/warehouse-setup-connect-form/index.js